import { APICore } from './apiCore';

const api = new APICore();

function dashboardList(): any {
    const baseUrl = '/dashboards';
    return api.getWithoutQuery(`${baseUrl}`, { headers: { 'Content-Type': 'application/json', Accept: "*/*", Authorization: `Bearer ${api.getLoggedInUser().token}` }});
}

export { dashboardList };